import script from "./PlanningShiftsList.component.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanningShiftsList.component.vue?vue&type=script&setup=true&lang=js"

import "./PlanningShiftsList.component.vue?vue&type=style&index=0&id=75959e11&lang=scss"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList});
